import { PestanasPagina } from '../componentes/PestanasPagina'
import { ConfirmarAgendamiento } from './ConfirmarAgendamiento'
import { Avisos } from './Avisos'
import { Incidencias } from './Incidencias'
import { PartesReparto } from './PartesReparto'

/**
 * Gestión — fusiona Confirmar + Avisos + Incidencias en una sola pantalla con
 * pestañas. Las tres comparten propósito: "listas de clientes/casos que
 * requieren una acción humana (llamar, notar, resolver)". Cada pestaña es
 * direccionable por ?tab= para conservar enlaces directos.
 */
export function Gestion() {
  return (
    <PestanasPagina
      titulo="Gestión"
      descripcion="Clientes y casos que requieren una acción: llamar, dar seguimiento o resolver incidencias."
      anclaTour="gestion-tabs"
      pestanas={[
        { id: 'semana', etiqueta: 'Esta semana', render: () => <ConfirmarAgendamiento sinCabecera /> },
        { id: 'seguimiento', etiqueta: 'Seguimiento', render: () => <Avisos sinCabecera /> },
        { id: 'incidencias', etiqueta: 'Incidencias', render: () => <Incidencias sinCabecera /> },
        { id: 'rutas', etiqueta: 'Partes de reparto', render: () => <PartesReparto /> },
      ]}
    />
  )
}
